export default __webpack_public_path__ + "static/media/logo_text.ff8ddb14.png";